import { useContext } from 'react';
import { statementContext } from '../contexts/StatementContext';

export function useStatement() {
  const value = useContext(statementContext);
  return value;
}
